<template>
  <Header class="app-header">
    <slot name="icon"></slot>
    <div class="masthead">
      <!--      <Icon type="ios-notifications" size="30" style="margin-right:10px;" />-->
      <div>
        <div class="user-tag">
          <Avatar icon="ios-person" />
          <span>{{ username }}</span>
        </div>
      </div>
      <div @click="signout()" class="logout">Logout</div>
    </div>
  </Header>
</template>
<script>
import { removeSession, logout } from "../../_services/authentication.service";
import { getAdministratorByEmail } from "../../_services/administrator.service";
import {bus} from "../../main";

export default {
  data() {
    return {
      username: "",
      email: ""
    };
  },
  methods: {
    signout() {
      logout({ Email: this.email })
        .then(res => {
          removeSession();
          this.$router.push({ name: "Login" });
        })
        .catch(err => {
          this.$Message.error("Unable to signout! Please try again later");
        });
    },
    getUserDetails() {
      let user_email = localStorage.getItem('user_email')
      this.email = user_email
      getAdministratorByEmail({Email:user_email}).then(res=>{
        this.username = res.data.data.Name
        // bus.$emit('sessionTimeoutChanged',res.data.data.sessionTimeout);
      }).catch(err=>{
        bus.$emit('requestError',err)
      })

    }
  },
  mounted() {
    this.getUserDetails();
  }
};
</script>
<style>
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.masthead {
  display: flex;
  align-items: center;
  margin: 0px 20px;
}
.masthead > * {
  margin: 0 16px;
}
.logout {
  cursor: pointer;
  color: #2db7f5;
}
.user-tag .ivu-avatar {
  margin-right: 8px;
}
</style>
